import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import JsonToYaml from "./pages/JsonToYaml";
import YamlToJson from "./pages/YamlToJson";
import JsonToXml from "./pages/JsonToXml";
import XmlToJson from "./pages/XmlToJson";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import "./assets/index.css";
import "./assets/App.css"

function App() {
  // ✅ Initialize dark mode from localStorage or system preference
  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem("theme");
    if (stored) return stored === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // ✅ Apply dark class and store preference
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-white text-black dark:bg-black dark:text-white">
        <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home darkMode={darkMode} />} />
            <Route path="/About" element={<About />} />
            <Route path="/json-to-yaml" element={<JsonToYaml />} />
            <Route path="/yaml-to-json" element={<YamlToJson />} />
            <Route path="/json-to-xml" element={<JsonToXml />} />
            <Route path="/xml-to-json" element={<XmlToJson />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
